export default __webpack_public_path__ + "da1e75c13a4bccf11ccdc52e55b1487c.svg";